// ===== Packages =====

import {
    getFunctions,
    httpsCallable,
}                               from 'firebase/functions';

// ===== Interfaces =====

import {
    IPartialUserItem,
}                               from '../interfaces';

const getPostAuthorItems = async ({
    test,
    postId,
}: {
    test: boolean,
    postId: string,
}): Promise<IPartialUserItem[]> => {
    const functions = getFunctions();
    const handleGetPostAuthorItems = httpsCallable<
        Record<
            string,
            boolean | string
        >,
        IPartialUserItem[]
    >(
        functions,
        'getPostAuthorItems',
    );
    return handleGetPostAuthorItems({
        test,
        postId,
    }).then((result) => {
        const partialAuthorItems = result.data as IPartialUserItem[];
        return partialAuthorItems;
    }).catch((err) => {
        throw err;
    });
};

export default getPostAuthorItems;
